/**
 * İşletme ismini URL-friendly slug formatına çevirir
 * @param {string} text - İşletme ismi
 * @returns {string} - Slug formatında isim
 */
export const slugify = (text) => {
  if (!text) return '';
  
  const turkishMap = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G',
    'ı': 'i', 'İ': 'I',
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U'
  };

  return text
    .toString()
    .split('')
    .map(char => turkishMap[char] || char)
    .join('')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Boşlukları tire ile değiştir
    .replace(/[^\w\-]+/g, '')      // Özel karakterleri kaldır
    .replace(/\-\-+/g, '-')        // Çoklu tireleri tek tire yap
    .replace(/^-+/, '')            // Başındaki tireleri kaldır
    .replace(/-+$/, '');           // Sonundaki tireleri kaldır
};

/**
 * İşletme bilgisinden slug oluşturur
 * @returns {string|null} - İşletme slug'ı veya null
 */
export const getBusinessSlug = () => {
  try {
    const business = localStorage.getItem('business');
    if (!business) return null;
    
    const businessData = JSON.parse(business);
    const businessName = businessData.name || businessData.businessName;
    
    if (!businessName) return null;
    
    return slugify(businessName);
  } catch (error) {
    console.error('Business slug oluşturma hatası:', error);
    return null;
  }
};

